import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import {
  _notificationHistory,
  _deleteAllNotification,
  _deleteNotification,
  _markAllNotificationAsRead,
  _markNotificationAsRead,
} from "@/services/clientnotification";

const initialState = {
  notifications: [],
  notificationLoading: false,
  showNotificationModal: false,
  currentNotification: {},
  notificationsPagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  unread_notifications: 0,
};

export const fetchNotificationHistory = createAsyncThunk(
  "clientNotification/fetchNotificationHistory",
  async (data, thunkAPI) => {
    let countOnly = _.isEmpty(data) ? false : data.countOnly;
    let paginationData =
      thunkAPI.getState().clientNotification.notificationsPagination;
    if (paginationData.isLastPage) {
      return;
    }
    const response = _notificationHistory({
      currentPage: paginationData.currentPage,
    });
    response
      .then((res) => {
        // console.log(res);
        const {
          data: {
            notification_history: data,
            message,
            unread_notification_count: notification_count,
            meta,
          },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        if (!countOnly) {
          thunkAPI.dispatch(
            updateNotificationPagination({
              currentPage: currentPage + 1,
              totalPage: lastPage,
              isLastPage: isLastPage,
            }),
          );
          let prevList =
            currentPage === 1
              ? []
              : _.uniq(thunkAPI.getState().clientNotification.notifications);
          let firstid = data.length > 0 ? data[0].id : null;
          if (
            prevList.length > 0 &&
            prevList.find((item) => item.id === firstid) !== undefined
          ) {
            //
          } else {
            thunkAPI.dispatch(updateNotifications([...prevList, ...data]));
          }
        }
        thunkAPI.dispatch(updateUnReadNotifications(notification_count));
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        thunkAPI.dispatch(updateNotificationLoading(false));
      });
  },
);

// mark notification as read
export const markNotificationAsRead = createAsyncThunk(
  "clientNotification/markNotificationAsRead",
  async (data, thunkAPI) => {
    let callback = data.callback || null;
    if (callback) {
      delete data.callback;
    }
    const { id, url = null } = data;
    let response = _markNotificationAsRead(id);
    response
      .then((res) => {
        let unreadNotifications =
          thunkAPI.getState().clientNotification.unread_notifications;
        thunkAPI.dispatch(updateUnReadNotifications(unreadNotifications - 1));
        if (url) {
          callback && callback();
        }
      })
      .catch((error) => {
        // handleAPICatch(error);
      });
  },
);

// mark all notification as read
export const markAllNotificationAsRead = createAsyncThunk(
  "clientNotification/markAllNotificationAsRead",
  async (data, thunkAPI) => {
    let response = _markAllNotificationAsRead();
    response
      .then((res) => {
        thunkAPI.dispatch(fetchNotificationHistory({ countOnly: true }));
        thunkAPI.dispatch(updateNotificationRead());
      })
      .catch((error) => {
        // handleAPICatch(error);
      });
  },
);

// delete notification
export const deleteNotification = createAsyncThunk(
  "clientNotification/deleteNotification",
  async (data, thunkAPI) => {
    let isRead = data.is_read;
    const response = _deleteNotification(data.id);
    response
      .then((res) => {
        let _clientNotification = thunkAPI.getState().clientNotification;
        let currentNotifications = _clientNotification.notifications;
        let currentUnread = _clientNotification.unread_notifications;
        if (!isRead) {
          thunkAPI.dispatch(updateUnReadNotifications(currentUnread - 1));
        }
        thunkAPI.dispatch(
          updateNotifications(
            currentNotifications.filter((item) => item.id !== data.id),
          ),
        );
      })
      .catch((error) => {
        // handleAPICatch(error);
      });
  },
);

// delete all notification
export const deleteAllNotification = createAsyncThunk(
  "clientNotification/deleteAllNotification",
  async (data, thunkAPI) => {
    const response = _deleteAllNotification(data);
    response
      .then((res) => {
        thunkAPI.dispatch(updateNotifications([]));
        thunkAPI.dispatch(updateUnReadNotifications(0));
      })
      .catch((error) => {
        // handleAPICatch(error);
      });
  },
);

const clientNotificationSlice = createSlice({
  name: "clientNotification",
  initialState,
  reducers: {
    updateNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    updateUnReadNotifications: (state, action) => {
      state.unread_notifications = action.payload;
    },
    updateNotificationLoading: (state, action) => {
      state.notificationLoading = action.payload;
    },
    updateNotificationPagination: (state, action) => {
      state.notificationsPagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    updateNotificationRead: (state, action) => {
      let id = action.payload;
      if (state.notifications.length) {
        state.notifications.map((item) => {
          if (id) {
            if (item.id === id) {
              item.is_read = 1;
            }
          } else {
            item.is_read = 1;
          }
        });
      }
      state.unread_notifications = 0;
    },
    toggleNotificationModal: (state, action) => {
      state.showNotificationModal = action.payload.show;
      state.currentNotification = {};
      if (action.payload.show) {
        state.currentNotification = action.payload.notification;
      }
    },
  },
});

export const {
  updateNotifications,
  updateUnReadNotifications,
  updateNotificationLoading,
  updateNotificationPagination,
  updateNotificationRead,
  toggleNotificationModal,
} = clientNotificationSlice.actions;

export default clientNotificationSlice.reducer;
